<ng-container [formGroup]="activateConsentFormGroup" *ngIf="property">
  @switch (step) {
    @case (0) {
      <ng-container [formGroupName]="'meter'">
        <div class="layer-heading">
          <div class="layer-title-small">{{ getActivateConsentTitle() }}</div>
        </div>

        <div class="scroll">
          <div class="layer-inner-content">
            <div class="layer-description activate-consent-description" *ngIf="nrjType === NrjType.ENEDIS">
              Pour profiter pleinement de votre espace Philogi, il est conseillé d’activer le recueil de vos données de consommations électriques pour le logement situé
              <span class="emphasis">{{ getAddressLabel() }}</span>.
              Pour ce faire, nous avons besoin d’identifier votre compteur, à l'aide du point de livraison (PDL).
              Ce numéro se trouve sur la <span class="emphasis">facture d'électricité</span>,
              ou via le <span class="emphasis">compteur Linky (appuyer sur + jusque numéro PRM)</span>.
            </div>
            <div class="layer-description activate-consent-description" *ngIf="nrjType === NrjType.GRDF">
              Pour profiter pleinement de votre espace Philogi, il est conseillé d’activer le recueil de vos données de consommations de gaz naturel pour le logement situé
              <span class="emphasis">{{ getAddressLabel() }}</span>.
              Pour ce faire, nous avons besoin d’identifier votre compteur, à l'aide du point de comptage et d'estimation (PCE).
              Ce numéro se trouve sur la <span class="emphasis">facture d'énergie</span>,
              ou via le <span class="emphasis">compteur Gazpar pour les logements équipés</span>.
            </div>
            <label for="meterId">{{ nrjType === NrjType.ENEDIS ? 'Numéro de point de livraison d\'électricité (PDL)' : 'Numéro de point de comptage et d\'estimation de gaz (PCE)' }} <span class="sub-label">14 chiffres</span></label>
            <ed-textfield innerId="meterId" placeholder="23050934500027" [formControlName]="'meterId'"></ed-textfield>
            <div class="refuse-link" *ngIf="nrjType === NrjType.ENEDIS" (click)="deny()">
              Pour le moment, je ne souhaite pas activer le recueil de mes consommations électriques
            </div>
            <div class="refuse-link" *ngIf="nrjType === NrjType.GRDF" (click)="deny()">
              Pour le moment, je ne souhaite pas activer le recueil de mes consommations de gaz naturel
            </div>
            <div class="button-group">
              <ed-button [colorSchema]="ButtonColors.Secondary" (click)="close()">{{ isNewUser ? 'Quitter' : 'Retour' }}</ed-button>
              <ed-button (click)="nextStep('meter')" [disabled]="!activateConsentFormGroup.get('meter')?.valid">Confirmer le {{nrjType === NrjType.ENEDIS ? "PDL" : "PCE"}}</ed-button>
            </div>
          </div>
        </div>
      </ng-container>
    }
    @case (1) {
      <ng-container [formGroupName]="'consent'">
        <div class="layer-heading">
          <div class="layer-title-small">{{ nrjType === NrjType.GRDF ?
            'Recueil des consommations de gaz naturel'
            : 'Recueil des consommations d\'électricité' }}</div>
        </div>

        <div class="scroll">
          <div class="layer-inner-content consent-info">
            <div>Les informations recueillies vous permettront facilement de...</div>
            <div class="bullet"><i class="icon icon-check"></i>Comparer votre consommations à des logements similaires</div>
            <div class="bullet"><i class="icon icon-check"></i>Identifier une surconsommation ou des équipements énergivores</div>
            <div class="bullet"><i class="icon icon-check"></i>Mesurer l'impact de vos gestes de réduction</div>
            <div class="bullet"><i class="icon icon-check"></i>Définir un programme de travaux adaptés</div>

            <div class="consent-box" *ngIf="nrjType === NrjType.ENEDIS">
              <div>Je certifie
                @if (name) {
                  , <span class="emphasis">{{ name }}</span>,
                }
                être le ou la titulaire du contrat d'abonnement électrique associé au PDL <span class="emphasis">{{ getMeterId() }}</span> et
                autorise <span class="emphasis">Energies Demain</span> à recueillir et sauvegarder les données suivantes pour les 2 précédentes et 5 prochaines années.
              </div>

              <div class="to-check">
                <ed-checkbox [formControlName]="'firstConsent'">
                  Consommation électrique avec un pas de temps de 30 à 60 minutes
                </ed-checkbox>
              </div>

              <div class="to-check">
                <ed-checkbox [formControlName]="'secondConsent'">
                  Informations tarifaires, puissance souscrite et calendrier fournisseur
                </ed-checkbox>
              </div>

              <div class="to-check">
                <ed-checkbox [formControlName]="'thirdConsent'">
                  Puissance maximale quotidienne atteinte
                </ed-checkbox>
              </div>
            </div>
            <div class="consent-box" *ngIf="nrjType === NrjType.GRDF">
              <ed-checkbox [formControlName]="'firstConsent'">
                Je certifie
                @if (name) {
                  , <span class="emphasis">{{ name }}</span>,
                }
                être le ou la titulaire du contrat d'abonnement de gaz naturel associé au PCE <span class="emphasis">{{ getMeterId() }}</span> et
                autorise <span class="emphasis">Energies Demain</span> à recueillir et sauvegarder mes consommations et les données techniques de mon compteur pour les 2 précédentes et 5 prochaines années.
              </ed-checkbox>
            </div>

            <div class="box-data">
              <div class="box-data-title" (click)="toggleDataInfo()">
                <i class="icon icon-shield-tick"></i>
                Protection des données et révocation
                <i class="icon icon-chevron-{{ showDataInfo ? 'up' : 'down' }}"></i>
              </div>
              <div class="box-data-description" *ngIf="showDataInfo">Vos données sont protégées et ne seront jamais partagées avec des tiers.<br>
                Vous pourrez accepter, ou refuser de les partager, avec les autres intervenants du carnet. Vous pourrez à tout moment annuler le recueil et supprimer l'intégralité des données sauvegardées.</div>
            </div>

            <div class="button-group">
              <ed-button [colorSchema]="ButtonColors.Secondary" (click)="deny()">Refuser</ed-button>
              <ed-button (click)="nextStep('consent')" [disabled]="!activateConsentFormGroup.get('consent')?.valid">Accepter</ed-button>
            </div>
          </div>
        </div>
      </ng-container>
    }
    @case (2) {
      <ng-container [formGroupName]="'share'">
        <div class="layer-heading">
          <div class="layer-title-small">{{ nrjType === NrjType.GRDF ?
            'Partage des consommations de gaz naturel'
            : 'Partage des consommations d\'électricité' }}</div>
        </div>

        <div class="scroll">
          <div class="layer-inner-content" [formArrayName]="'shareOptions'">
            <div class="layer-description">
              Pour aider les autres intervenants du logement à identifier <span class="emphasis">les meilleures stratégies d'économies d'énergie dont vous pourrez bénéficier</span>,
              vous avez la possibilité de partager le suivi de vos consommations, en définissant l'échelle temporelle de votre choix.
            </div>

            <ng-container *ngFor="let entity of shareOptionsArray.controls; let i = index" [formGroupName]="i">
              <label>Partage des données avec {{ entity.get('orgName')?.value || entity.get('userName')?.value }}
                <span class="sub-label" *ngIf="!!entity.get('isOwner')?.value"> Propriétaire</span>
                <span class="sub-label" *ngIf="entity.get('orgType')?.value as orgType"> {{ orgTypeMap.get(orgType) }}</span>
              </label>
              <div class="panel-row">
                <label class="ed-radio-box" *ngFor="let item of energyShareMap | keyvalue">
                  <ng-container *ngIf="nrjType === NrjType.ENEDIS || nrjType === NrjType.GRDF && item.key !== EnergyShare.Hourly">
                    <input type="radio" [value]="item.key" [formControlName]="'energyShare'">
                    <div class="box-content">{{ item.value }}</div>
                  </ng-container>
                </label>
              </div>
            </ng-container>

            <div class="button-group">
              <ed-button [colorSchema]="ButtonColors.Secondary" (click)="previousStep()">Retour</ed-button>
              <ed-button (click)="accept()" [loading]="isLoading">Accepter</ed-button>
            </div>
          </div>
        </div>
      </ng-container>
    }
    @case (3) {
      <div class="scroll">
        <div class="layer-inner-content centered">
          <ng-container *ngIf="nrjType === NrjType.ENEDIS">
            <div class="icon-box valid"><i class="icon icon-check-circle"></i></div>
            <div class="layer-heading">
              <div class="layer-title-small success-text">Le recueil est activé !</div>
            </div>
            <div class="layer-description big">
              Nous vous remercions d'avoir activé le recueil des données de votre compteur d'électricité.<br>
              Les données seront accessibles sur votre carnet du logement sous 48h maximum.
            </div>
          </ng-container>
          <ng-container *ngIf="nrjType === NrjType.GRDF">
            <div class="icon-box warning"><i class="icon icon-mail-02"></i></div>
            <div class="layer-heading">
              <div class="layer-title-small warning">Attente de confirmation par mail</div>
            </div>
            <div class="layer-description alternate">
              Vous allez recevoir un mail intitulé <span class="emphasis">Nouvelle demande d'accès à vos données de gaz</span> de la part de GRDF. Vous devriez le recevoir dans la journée, vérifiez votre dossier spam.
            </div>
            <div class="layer-description alternate">
              Cliquez sur <span class="emphasis">Gérer mes accès</span> et validez la demande d'accès à vos données sur GRDF. Vos données seront transmises et visibles sur votre compte dans un délai de 4 jours.
            </div>
            <div class="banner warning">
              <i class="icon icon-alert-circle"></i>
              Attention ! Si vous « Refusez » ou « Révoquez », vous ne pourrez plus accéder à vos données.
            </div>
          </ng-container>

          <div class="bottom-buttons">
              <ed-button class="end-button" [colorSchema]="ButtonColors.Secondary" (click)="end()">{{ getEndButtonLabel() }}</ed-button>
              @if(loggedUser.invitationToken && step === 3) {
                <ed-button class="end-button" [colorSchema]="ButtonColors.Primary" (click)="signup()">Créer mon compte</ed-button>
              }
          </div>
        </div>
      </div>
    }
    @case (4) {
      <div class="scroll">
        <div class="layer-inner-content centered">
          <div class="layer-heading">
            <div class="layer-title-small error">Désactiver le recueil des données</div>
          </div>
          <div class="layer-description">
            <p class="bigger">Confirmez vous la désactivation du recueil des données de consommations
              {{ nrjType === NrjType.ENEDIS ? "d'électricité" : 'de gaz'}} du logement pour le
              <b>point de livraison {{ getMeterId() }}</b>, ainsi que la suppression des données collectées ?</p>

          </div>
          <div class="bottom-buttons">
            <ed-button [colorSchema]="ButtonColors.Secondary" (click)="end()">Annuler</ed-button>
            <ed-button [colorSchema]="ButtonColors.Red" (click)="revoke()">Désactiver</ed-button>
          </div>
        </div>
      </div>
    }
    @case (5) {
      <div class="scroll">
        <div class="layer-inner-content centered">
          <div class="layer-heading">
            <div class="layer-title-small error">Refus du consentement</div>
          </div>
          <div class="layer-description">
            <p class="bigger">Vous venez de refuser le recueil des données de consommation  {{ nrjType === NrjType.ENEDIS ? "d'électricité" : 'de gaz'}} du logement.
              @if (loggedUser.invitationToken) {
                Vous pouvez toujours changer d'avis et profiter pleinement de votre espace Philogi en activant le recueil des données de consommation depuis votre compte personnel.
              }
            </p>
          </div>
          <div class="bottom-buttons">
            <ed-button [colorSchema]="ButtonColors.Secondary" (click)="end()">Terminer</ed-button>
            @if (loggedUser.invitationToken) {
              <ed-button [colorSchema]="ButtonColors.Primary" (click)="signup()">Créer mon compte</ed-button>
            }
          </div>
        </div>
      </div>

    }
    @case (6) {
      <div class="scroll">
        <div class="layer-inner-content centered">
          <div class="icon-box valid"><i class="icon icon-check-circle"></i></div>
          <div class="layer-heading">
            <div class="layer-title-small success-text">Le recueil est désactivé</div>
          </div>
          <div class="layer-description big">
            Vous venez de désactiver le recueil des données de votre compteur {{ nrjType === NrjType.ENEDIS ? "d'électricité" : 'de gaz' }}. Les données collectées associées sont également supprimées.
          </div>

          <div class="bottom-buttons">
              <ed-button class="end-button" [colorSchema]="ButtonColors.Secondary" (click)="end()">Terminer</ed-button>
              @if(loggedUser.invitationToken) {
                <ed-button class="end-button" [colorSchema]="ButtonColors.Primary" (click)="signup()">Créer mon compte</ed-button>
              }
          </div>
        </div>
      </div>
    }
  }
</ng-container>
